module.exports = __webpack_public_path__ + "static/media/editLogo.f498c085.svg";